import axios from "axios";
import { setupInterceptors } from "./api";
const config = require("../config");

const instance = axios.create({
  baseURL: config.api,
});

setupInterceptors(instance);

export default instance;
